import { render, staticRenderFns } from "./PermissionMatrixMgr.vue?vue&type=template&id=43f0426a"
import script from "./PermissionMatrixMgr.vue?vue&type=script&lang=js"
export * from "./PermissionMatrixMgr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports